<!--
/****************************************************************************************************************
*  ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
<div style="width: 100%; box-sizing: border-box" [formGroup]="form">
  @switch (field.controlType) {
    @case ('textbox') {
      <mat-form-field style="width: 100%;">
        <mat-label>{{ field.label }}</mat-label>
        @if (field.validators) {
          <input matInput [readonly]="field.readonly" attr.aria-label="{{ field.label  }}"
            title="{{ field.value }}" formControlName="{{ field.key }}" maxlength="{{ field.validators['maxlength'] }}"
            [required]="field.validators['required']">
        } @else {
          <input matInput [readonly]="field.readonly" attr.aria-label="{{ field.label  }}"
            formControlName="{{ field.key }}">
          }
          @if (form.controls[field.key].hasError('required')) {
            <mat-error>
              {{ field.validators['required'].errorMessage }}
            </mat-error>
          }
          @if (!form.controls[field.key].hasError('required') && form.controls[field.key].hasError('pattern')) {
            <mat-error>
              {{ field.validators['pattern'].errorMessage }}
            </mat-error>
          }
          @if (!form.controls[field.key].hasError('required') && form.controls[field.key].hasError('minlength')) {
            <mat-error>
              {{ field.validators['minlength'].errorMessage }}
            </mat-error>
          }
        </mat-form-field>
      }
      @case ('checkbox') {
        <mat-checkbox [disabled]="field.readonly" formControlName="{{ field.key }}"
          attr.aria-label="{{ field.label  }}">
        {{ field.label }}</mat-checkbox>
      }
      @case ('dropdown') {
        <mat-form-field style="width: 100%;">
          <mat-label>{{ field.label }}</mat-label>
          @if (!readonly) {
            <mat-select [disabled]="field.readonly" [required]="field.validators && field.validators['required']"
              formControlName="{{ field.key }}" [(value)]="field.selected"
              (selectionChange)="onDropdownSelectionChange()" attr.aria-label="{{ field.label  }}">
              @for (option of field.options; track option) {
                <mat-option [value]="option.value" attr.aria-label="{{ option.viewValue  }}">
                  {{ option.viewValue }}
                </mat-option>
              }
            </mat-select>
          } @else {
            <input matInput [readonly]="true" title="{{ field.value }}" formControlName="{{ field.key }}" attr.aria-label="{{ field.label  }}">
          }
          @if (form.controls[field.key].hasError('required')) {
            <mat-error>
              {{ field.validators['required'].errorMessage }}
            </mat-error>
          }
        </mat-form-field>
      }
      @case (field.controlType === 'datepicker' || field.controlType === 'customdatepicker' ? field.controlType : '') {
        <mat-form-field
          class="mat-form-field-width" style="width: 100%;">
          <mat-label>{{ field.label }}</mat-label>
          <input matInput [matDatepicker]="picker" (click)="picker.open()"
            formControlName="{{ field.key }}" [max]="field.max" [min]="field.min" attr.aria-label="{{ field.label  }}"
            [required]="field.validators && field.validators['required']" [readonly]="true">
            @if (form.controls[field.key].hasError('required')) {
              <mat-error>
                {{ field.validators['required'].errorMessage }}
              </mat-error>
            }
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #picker [disabled]="readonly || field.readonly"></mat-datepicker>
          </mat-form-field>
        }
      }
    </div>

